import { arrayOf } from 'prop-types';
import React from 'react';

import Table from '../../generic/Table';
import opportunityAgreementsColumns from '../../opportunities/opportunity-agreements-columns';
import { opportunityShape } from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';

export function AgreementRelatedOpportunitiesTable({ opportunities }) {
  return (
    <Table
      className="c-nested-table"
      data={opportunities}
      columns={opportunityAgreementsColumns}
      minRows={1}
      showPagination={false}
      filterable={false}
      sortable={false}
    />
  );
}

AgreementRelatedOpportunitiesTable.propTypes = {
  opportunities: arrayOf(opportunityShape.isRequired).isRequired,
};

const AgreementRow = withResolved({
  query: api.getOpportunities,
  deriveQueryArgs: ({ agreementId }) => ({
    search: {
      fullDetails: true,
      agreementIds: Number.parseInt(agreementId, 10),
    },
  }),
  as: 'opportunities',
})(AgreementRelatedOpportunitiesTable);

export default AgreementRow;
